export interface IGlobalContext {
	/**
	 * Base64 representation of the the origin url usually www.toctoc.com
	 */
	originUrl?: string,
}

// eslint-disable-next-line no-unused-vars 
export enum STATUS {
	// eslint-disable-next-line no-unused-vars
	idle,
	// eslint-disable-next-line no-unused-vars
	pending,
	// eslint-disable-next-line no-unused-vars
	error,
	// eslint-disable-next-line no-unused-vars
	init
}
